export default function AdminPanel() {

  return (
      <p>پنل ادمین</p>
  );
};